import React from "react";
import Navbar from "../../components/Navbar/index.tsx";
import Features from "../../components/Features/index.tsx";

const FeaturesPage = () => {
  return (
    <div className="page">
      <Navbar />
      <div className="pt-16" />
      <Features />
    </div>
  );
};

export default FeaturesPage;
